import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.shared.reception-service': {
         notSelected: 'nie wybrano',
         receptionServices: 'Usługi recepcyjne',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.shared.reception-service');
